import { useContext } from "react";
import { NavigationTabContext } from "./NavigationTabContext";

export const useNavigationTabContext = () => {
  const context = useContext(NavigationTabContext);
  if (!context) throw new Error("NavigationTabContext cannot be found");
  return context;
};
